<template>
  <div class="form-wrapper" v-on:keyup="keydown">
    <div class="form">
      <div>
        <div class="logo">
          <a href="https://easydelivery.com.br" target="_blank">
            <img src="https://cdn.easydelivery.com.br/easy_logo_pink.svg" />
          </a>
        </div>
        <div class="form-container">
          <div v-if="loginLoading" class="login-loading">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <p class="welcome animated">Bem - vindo</p>
          <div class="d-flex justify-center">
            <p class="message">Novo usuário?</p>
            <p
              @click="$router.replace({ name: 'signup' })"
              class="create-account"
            >
              Crie uma conta
            </p>
          </div>
          <form action="javascript:void(0)" class="form-login">
            <base-input
              v-if="showEnvInput"
              :label="'Nome de ambiente'"
              :type="'text'"
              :valid="!environmentError && !errorLogin"
              id="environment"
              name="environment"
              v-model="oLogin.environment"
              @keyup.enter="sendLogin"
              @focus="environmentError = null"
              ref="environment"
              class="mb_25 pt_0"
              :design="'one'"
            />
            <base-input
              :label="'Nome de usuário'"
              :type="'text'"
              :valid="!usernameError && !errorLogin"
              id="user"
              name="username"
              v-model="oLogin.username"
              @keyup.enter="sendLogin"
              @focus="usernameError = null"
              ref="username"
              class="mb_25 pt_0"
              :design="'one'"
            />
            <base-input
              :label="'Sua senha'"
              :type="'password'"
              :valid="!passwordError && !errorLogin"
              id="password"
              name="password"
              v-model="oLogin.password"
              @keyup.enter="sendLogin"
              @focus="passwordError = null"
              ref="password"
              class="mb_25 pt_0"
              design="one"
            />

            <div
              style="margin-top: -10px"
              class="mb_15"
              v-if="
                errorLogin || usernameError || passwordError || environmentError
              "
            >
              <base-message v-if="usernameError == 'required'" design="red"
                >O campo usuário é obrigatório.</base-message
              >
              <base-message v-if="passwordError == 'required'" design="red"
                >A senha é obrigatória.</base-message
              >
              <base-message v-if="environmentError == 'required'" design="red"
                >O Ambiente é obrigatório.</base-message
              >
              <base-message v-if="environmentError == 'forbidden'" design="red"
                >Sem permissão para acessar lojas.</base-message
              >
              <base-message
                v-if="errorLogin && !usernameError && !passwordError"
                design="red"
                >Usuário e/ou senha incorretos!</base-message
              >
            </div>

            <base-button
              :text="'Entrar'"
              class="w-100 big"
              @click="sendLogin"
            ></base-button>

            <div class="d-flex align-center justify-center">
              <p
                @click="$router.replace({ name: 'forgotpassword' })"
                class="forgot-password"
              >
                Esqueceu sua senha?
              </p>
            </div>

            <div
              v-if="!isAppDesktop() && getOS() === 'Windows'"
              class="download"
            >
              <i class="fal fa-desktop" />
              <a href="https://easydelivery.com.br/downloads/" target="_blank"
                >Baixar para Windows</a
              >
            </div>

            <div
              v-if="!isAppMobile() && getOS() === 'Android'"
              class="download"
            >
              <img
                src="@/assets/img/playstore.svg"
                alt="Baixar na Play Store"
              />
              <a href="https://easydelivery.com.br/downloads/" target="_blank"
                >Baixar na Play Store</a
              >
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/login.css';
import { mapState } from 'vuex';
import getOS from '@/mixins/getOS.js';
import apiLogin from '@/api/account';
import { setXUserKey, setXAPIEnv, getXUserKey } from '@/plugins/account';
import router from '@/router';
import Utils from '@/utils';
import { scrollToMe } from '@/plugins/scroll';
import AppBridge from '@/plugins/app';
import DesktopBridge from '@/plugins/desktop';
import { EVENTS as TrackEvents } from '@/plugins/trackDriver/MixPanelDriver';
import OneSignalTool from '@/utils/onesignal.js';

// UI

import BaseInput from '@/components/Input';
import BaseBox from '@/components/Box';
import BaseLogo from '@/components/Logo';
import BaseButton from '@/components/Button';
import BaseMessage from '@/components/Message';
import BaseTitle from '@/components/Title';

export default {
  mixins: [getOS],
  data() {
    return {
      loginLoading: false,
      usernameError: null,
      passwordError: null,
      environmentError: null,
      showEnvInput: false,
      oLogin: {
        password: '',
        username: '',
        environment: '',
        errorMessage: '',
      },
      errorLogin: null,
    };
  },
  async beforeMount() {
    if (AppBridge.isApp()) {
      this.loginLoading = true;
      AppBridge.emit('onOpenUpdate');
      AppBridge.listen('noOpenUpdate', () => {
        this.loginLoading = false;
      });
    }
  },
  mounted() {
    if (AppBridge.isApp()) {
      AppBridge.emit('onLockOrientation');
    }

    document.onkeydown = this.keydown;

    const lastEmail = localStorage.getItem('lastLoginEmail');
    if (lastEmail && lastEmail !== 'null') {
      this.oLogin.username = localStorage.getItem('lastLoginEmail');
      return this.$refs.password.focus();
    }

    this.$refs.username.focus();
  },
  methods: {
    isAppDesktop() {
      return DesktopBridge.isDesktop();
    },
    isAppMobile() {
      return AppBridge.isApp();
    },
    keydown(event) {
      if (
        event.ctrlKey &&
        event.altKey &&
        [48, 96].indexOf(event.keyCode) > -1
      ) {
        this.showEnvInput = !this.showEnvInput;

        this.errorLogin = '';
        this.oLogin.password = '';
        this.oLogin.username = '';
      }
    },
    async sendLogin() {
      const loginIsValid = this.validateLogin();

      if (!loginIsValid) {
        return;
      }
      if (this.showEnvInput) {
        if (this.oLogin.environment === '') {
          this.environmentError = 'required';
          return false;
        }
        const self = this;
        const response = await apiLogin.SupportLogin(this.oLogin);
        if (!response._data) {
          this.loginLoading = false;
          this.oLogin.errorMessage = 'Usuário e/ou senha incorreto!';
          this.errorLogin = 'Usuário e/ou senha incorreto!';
          return false;
        }
        const result = response.getData(false);

        setXUserKey(result['x-user-key']);
        setXAPIEnv(
          Array.isArray(result['x-api-env'])
            ? result['x-api-env'][0]
            : result['x-api-env']
        );
        if (!result.permissions.includes('ENVIRONMENT_LOGIN')) {
          this.environmentError = 'forbidden';
          return false;
        }
        const config = await self.$store.dispatch('store/getConfigurations');
        const deliveryConfig = this.$store.dispatch(
          'deliveryPlatform/loadConfigurations'
        );
        if (self.$store.state.store.onBoardDone) {
          return router.push({ name: 'pedidos' });
        }

        return false;
      }
      const self = this;
      self.loginLoading = true;
      self.oLogin.errorMessage = '';
      const response = await apiLogin.Login(self.oLogin);
      const result = response.getData(false);

      if (!result) {
        self.loginLoading = false;
        self.oLogin.errorMessage = response.getErrors()[0];
        self.errorLogin = response.getErrors()[0];
        return false;
      }

      localStorage.setItem('lastLoginEmail', self.oLogin.username);
      setXUserKey(result['x-user-key']);
      setXAPIEnv(
        Array.isArray(result['x-api-env'])
          ? result['x-api-env'][0]
          : result['x-api-env']
      );

      const config = await self.$store.dispatch('store/getConfigurations');
      const deliveryConfig = this.$store.dispatch(
        'deliveryPlatform/loadConfigurations'
      );
      const userResponse = await apiLogin.me();
      const user = userResponse.getData({ id: null, name: null });

      if (!AppBridge.isApp()) {
        OneSignalTool.verifySubscription()
          .then(() => {
            return true;
          })
          .catch((e) => {
            console.log(`Erro ao inscrever no OneSignal: ${e.message}`);
            return false;
          });
      }
      // O register deverá ser chamado quando o usuário se identificar
      await globalThis.Tracker.register(user.id, {
        $name: user.name,
        username: user.username,
        $email: user.email
      });

      await globalThis.Tracker.trigger(TrackEvents.LOGIN, { time: new Date() });

      if (!self.$store.state.store.onBoardDone) {
        return router.push({ name: 'onboard' });
      }

      if (DesktopBridge.isDesktop()) {
        DesktopBridge.emit('onLoginUpdate');
      }

      if (AppBridge.isApp()) {
        AppBridge.emit('onLoginUpdate');
        AppBridge.emit('onUnlockOrientation');
      }

      router.push({ name: 'pedidos' });

      return false;
    },
    validateLogin() {
      if (this.oLogin.username === '') {
        this.usernameError = 'required';
        return false;
      }

      if (this.oLogin.password === '') {
        this.passwordError = 'required';
        return false;
      }

      return true;
    },
    scrollToMe() {
      scrollToMe('body', -80);
    },
  },
  components: {
    BaseInput,
    BaseBox,
    BaseLogo,
    BaseButton,
    BaseMessage,
    BaseTitle,
  },
  watch: {
    updateLater(status) {
      this.loginLoading = !status;
    },
  },
  computed: {
    ...mapState({
      updateLater: (state) => state.store.updateLater,
    }),
  },
};
</script>
